import React, { useEffect, useState } from "react";
import "../../Main.css";
import { Box, Grid, useMediaQuery } from "@mui/material";
import Chat from "../chat/Chat";
import {
  getSavingVariables,
  getSavingVariablesFil,
} from "../../../../utils/firestoreQuery";
import BG from "../../../../assets/qlt5_intro-background.png";
import ArrowForwardRounded from "@mui/icons-material/ArrowForwardRounded";
import { useSelector } from "react-redux";

function Intro({ start, handleCLick }) {
  const [objData, setObjData] = useState();
  const lang = useSelector((state) => state.chat.language);
  const md = useMediaQuery("(min-width:900px)", { noSsr: true });
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (lang === "ENG") {
          const documentSnapshot = await getSavingVariables().get();
          if (documentSnapshot.exists) {
            const data = documentSnapshot.data();

            setObjData(data);
          } else {
            console.log("Document does not exist");
          }
        } else if (lang === "FIL") {
          const documentSnapshot = await getSavingVariablesFil().get();
          if (documentSnapshot.exists) {
            const data = documentSnapshot.data();

            setObjData(data);
          } else {
            console.log("Document does not exist");
          }
        }
      } catch (error) {
        console.error("Error fetching document:", error);
      }
    };

    fetchData();
  }, [lang]);

  const buttonGoMarketElement = (
    <div
      style={{
        // marginTop: "-1rem",
        cursor: "pointer",
        marginBottom: ".5rem",
        float: "right",
        backgroundColor: "#1cc4ec",
        padding: "1rem",
        borderRadius: "2rem",
        color: "white",
        // width: "26%",
      }}
      onClick={() => handleCLick()}
    >
      <b>
        {lang === "ENG" ? "Go to market" : "Pumunta sa Palengke"}{" "}
        <ArrowForwardRounded
          sx={{
            width: "1.8rem",
            height: "2rem",
            marginTop: "-1.67rem",
            marginBottom: "-.7rem",
            marginLeft: ".2rem",
          }}
        />
      </b>
    </div>
  );

  return (
    <>
      <Box
        sx={{
          backgroundImage: md && `url(${BG})`,
          backgroundSize: md && "100% 100%",
          height: md ? "100vh" : "auto",
          backgroundColor: "#e1fecb",
        }}
      >
        {start && (
          <>
            <div
              style={{
                position: "relative",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <img
                src={BG}
                style={{
                  display: "block",
                  width: "100%",
                  height: md ? "100vh" : "auto",
                  objectFit: "fill",
                }}
                alt="image"
              />

              <Box
                style={{
                  position: md ? "absolute" : "inherit",
                  width: "100%",
                  height: "100%",
                  paddingTop: "1rem",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    backgroundColor: "#FFFFFF40",
                    height: "45%",
                    padding: "1.5rem",
                    borderRadius: "1rem",
                    width: "70%",
                    marginLeft: "15%",
                    marginBottom: "1rem",
                    marginTop: md ? "5rem" : "1rem",
                  }}
                >
                  {objData && (
                    <Chat
                      pageLang={lang}
                      buttonElement={buttonGoMarketElement}
                      objData={objData.intro}
                      mainContainer={{
                        height: md ? "inherit" : "400px",
                        flexGrow: "1",
                      }}
                    />
                  )}
                </Box>
              </Box>
            </div>
          </>
        )}
      </Box>
    </>
  );
}

export default Intro;
